
import { defineComponent } from "vue";
import NavMobile from "@/components/mobile/NavMobile.vue";
import NavDesktop from "@/components/desktop/NavDesktop.vue";
import NavTablet from "@/components/tablet/NavTablet.vue";

export default defineComponent({
  components: { NavMobile, NavTablet, NavDesktop },  
});
